export default {
  'menu.aiScenes': 'Application scenes',
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.myApps': 'My Apps',
  'menu.markets.apps': 'App Market',
  'menu.markets.skills': 'Skill Market',
  'menu.markets.mcp': 'MCP Market',
  'menu.markets.plugins': 'Plugin Market',
  'menu.businessAppMarket': 'Business App Market',
  'menu.management': 'Enterprise Management',
  'menu.management.tenants': 'Tenant Management',
  'menu.management.tenantDetail': 'Tenant Detail',
  'menu.management.users': 'User Management',
  'menu.management.userDetail': 'User Detail',
  'menu.management.myTenants': 'Tenant Settings',
  'menu.management.myTenantDetail': 'Tenant Settings',
  'menu.management.identities': 'Members',
  'menu.management.departments': 'Departments',
  'menu.management.roles': 'Permissions',
  'menu.management.auditLog': 'Audit Log',
  'menu.platformManagement': 'Platform Management',
  'menu.platformManagement.applications': 'Application management',
  'menu.platformManagement.pluginApplications': 'Plugin applications',
  'menu.platformManagement.applicationPublicationReview': 'App Listing Review',
  'menu.platformManagement.taxonomies': 'Taxonomies',
  'menu.platformManagement.aiRuntime': 'Model Hub',
  'menu.platformManagement.events': 'Event Engine',
  'menu.platformManagement.clusters': 'Clusters',
  'menu.platformManagement.applicationStorage': 'Application Storage',
  'menu.platformManagement.productCatalog': 'Product Catalog',
  'menu.platformManagement.tenantPackages': 'Plans',
  'menu.platformManagement.tenantEntitlements': 'Tenant Entitlements',
  'menu.platformManagement.paymentOrders': 'Payment Orders',
  'menu.platformSettings': 'Platform Settings',
  'menu.platformSettings.branding': 'Branding',
  'menu.platformSettings.llm': 'Default Models',
  'menu.platformSettings.storage': 'Default Storage',
  'menu.platformSettings.quota': 'Usage Limits',
  'menu.platformSettings.features': 'Platform Features',
  'menu.platformSettings.permissions': 'Platform Permissions',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.settings': 'System Settings',
  'menu.settings.permissions': 'Permission Management',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.account.switchTenant': 'Switch Organization',
  'menu.account.switchTenant.empty': 'No organizations available',
  'menu.account.switchTenant.create': 'Create/Join Organization',
  'menu.account.switchTenant.delete': 'Delete Organization',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
